import React, { useEffect, useRef, useState } from "react";
import HeadWithSubHead from "../../common/HeadWithSubHead";
import { Col, Form, Row } from "react-bootstrap";
import InputField from "../../common/InputFieldWithDropDown/InputField";
import CommonButton from "../../component/CommonButton/CommonButton";
import styles from "./OfflineTransaction.module.css";
import IndiaImg from "../../public/assets/inflag.svg";
import NewHeader from "../NavBar/newHeader";
import russiaFlag from "../../public/assets/russiaflag.svg";
import usFlag from "../../public/assets/usflag.svg";
import { useNavigate } from "react-router";
import {
  getOfflineExchangeRate,
  offlineTransactionCreation,
  purposefetchData,
} from "../../api";
import { useMyContext } from "../../myContext";
import { addCommasInPrice, bigDecimalOp, decimalAdjust } from "../../utils";
import CommonModal from "../../common/Modal/modal";
import InfoBox from "../../common/InfoBox/InfoBox";

function OfflineTransaction() {
  const [loading, setLoading] = useState(false);
  const [amountRUB, setAmountRUB] = useState();
  const [labelValue, setLabelValue] = useState();
  const [AmountConversion, setAmountConversion] = useState("--");
  const [amountExceedError, setAmountExceedError] = useState("");
  const [showError, setShowError] = useState("");
  const [accountDetail, setAccountDetail] = useState();
  const [loanCheckBox, setLoanCheckBox] = useState(false);
  const [purposeId, setPurposeId] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [transactionDetail, setTransactionDetail] = useState();
  const inputE1 = useRef(null);
  const navigate = useNavigate();
  const [currency, setCurrency] = useState("RUB");
  const [quoteRate, setQuoteRate] = useState();
  const [paymentMethod, setPaymentMethod] = useState("Online");
  const [totalAmount, setTotalAmount] = useState();
  const { themeColor } = useMyContext();
  const handleChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const allLabelVal = [
    {
      Head: "INR",
      Value: "--",
    },
    {
      Head: "Tax Collected at Source [TCS]",
      Value: "--",
    },
    {
      Head: "Goods and Service Tax",
      Value: "--",
    },
    {
      Head: "Transfer Fee",
      Value: "--",
    },
  ];

  const currencyDropdown = [
    {
      label: "RUB",
      value: "RUB",
      image: russiaFlag,
    },
    {
      label: "USD",
      value: "USD",
      image: usFlag,
    },
  ];

  const fetchPurposeData = async () => {
    try {
      purposefetchData().then((response) => {
        setPurposeId(response?.data[0]?.purposeId);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (sessionStorage.getItem("offlineUserStatus") !== "offlineTransaction") {
      navigate("/transaction-detail", { replace: true });
      window.location.reload();
    }
    fetchPurposeData();
  }, []);

  useEffect(() => {
    setLabelValue(allLabelVal);
    if (inputE1.current) {
      inputE1.current.focus();
    }
    let accountDetail = sessionStorage.getItem("offlineAccountDetail");
    if (accountDetail !== "") {
      let accountDetailStringInObject = JSON.parse(accountDetail);
      setAccountDetail({ ...accountDetailStringInObject });
    }
  }, [inputE1]);

  const getExchangeRate = async () => {
    let mode = paymentMethod === "Online" ? "ONLINE" : "CASH";
    const partnerShortCode = sessionStorage.getItem("partnerShortCode");
    try {
      const resp = await getOfflineExchangeRate(
        mode,
        currency,
        partnerShortCode
      );
      if (resp?.data?.quote) {
        setQuoteRate(resp?.data?.quote);
      }
    } catch (e) {}
  };

  useEffect(() => {
    getExchangeRate();
  }, [currency, paymentMethod]);

  useEffect(() => {
    if (amountRUB > 0 && quoteRate) {
      const calculatedRUBtoINR = bigDecimalOp(amountRUB, quoteRate, "multiply");
      let calculatedtcs;

      if (calculatedRUBtoINR >= 700001) {
        if (loanCheckBox) {
          calculatedtcs = bigDecimalOp(0.005, calculatedRUBtoINR, "multiply");
        } else {
          calculatedtcs = bigDecimalOp(0.05, calculatedRUBtoINR, "multiply");
        }
      } else {
        calculatedtcs = 0;
      }

      let taxableAmount;
      if (calculatedRUBtoINR <= 100000) {
        taxableAmount = Math.max(
          bigDecimalOp(0.01, calculatedRUBtoINR, "multiply"),
          250
        );
      } else if (calculatedRUBtoINR > 100000 && calculatedRUBtoINR <= 1000000) {
        const minusval = bigDecimalOp(calculatedRUBtoINR, 100000, "subtract");
        const mulval = bigDecimalOp(0.005, minusval, "multiply");
        taxableAmount = bigDecimalOp(mulval, 1000, "add");
      } else if (calculatedRUBtoINR > 1000000) {
        const minusval = bigDecimalOp(calculatedRUBtoINR, 1000000, "subtract");
        const mulval = bigDecimalOp(0.001, minusval, "multiply");
        taxableAmount = Math.min(bigDecimalOp(mulval, 5500, "add"), 60000);
      } else {
        taxableAmount = 0;
      }

      const calculatedgst = bigDecimalOp(0.18, taxableAmount, "multiply");

      const updatedVal = labelValue.map((item) => {
        switch (item.Head) {
          case "INR":
            return {
              ...item,
              Value: addCommasInPrice(calculatedRUBtoINR.toString()),
            };
          case "Transfer Fee":
            return { ...item, Value: "1000" };
          case "Tax Collected at Source [TCS]":
            return {
              ...item,
              Value: addCommasInPrice(calculatedtcs.toString()),
            };
          case "Goods and Service Tax":
            return {
              ...item,
              Value: addCommasInPrice(calculatedgst.toString()),
            };
          default:
            return item;
        }
      });

      setLabelValue(updatedVal);
      const addINRandTCS = bigDecimalOp(
        calculatedRUBtoINR,
        calculatedtcs,
        "add"
      );
      const addTCSFees = bigDecimalOp(calculatedgst, 1000, "add");
      const total = bigDecimalOp(addINRandTCS, addTCSFees, "add");
      const totalDecimalAdjust = decimalAdjust("ceil", total, -2);
      setTotalAmount(totalDecimalAdjust);
      setAmountConversion(addCommasInPrice(totalDecimalAdjust));
    } else if (amountRUB === "") {
      const updatedVal = labelValue.map((item) => {
        switch (item.Head) {
          case "INR":
            return { ...item, Value: "--" };
          case "Transfer Fee":
            return { ...item, Value: "--" };
          case "Tax Collected at Source [TCS]":
            return { ...item, Value: "--" };
          case "Goods and Service Tax":
            return { ...item, Value: "--" };
          default:
            return item;
        }
      });
      setLabelValue(updatedVal);
      setAmountConversion("--");
    }
  }, [amountRUB, loanCheckBox, quoteRate, paymentMethod, currency]);

  const handleToggleModal = () => {
    setOpenModal(false);
  };

  const inputAmount = (e) => {
    const inputValue = e.target.value;
    if (
      inputValue >= 0 &&
      inputValue.indexOf(".") === -1 &&
      inputValue.length <= 7
    ) {
      setAmountRUB(inputValue);
    }
  };

  const handleConfirmTransfer = async () => {
    setShowError("");
    setLoading(true);
    try {
      const body = {
        amount: totalAmount,
        remitterId: sessionStorage.getItem("offlineremitterId"),
        studentId: sessionStorage.getItem("offlineStudentId"),
        purposeId: purposeId,
        currency: currency,
        mode: paymentMethod === "Online" ? "ONLINE" : "CASH",
      };
      const resp = await offlineTransactionCreation(body);
      sessionStorage.setItem("offlineTransactionId", resp?.data?.transactionId);
      if (resp?.status === 200) {
        setTransactionDetail(resp?.data);
        setOpenModal(true);
      } else {
        setShowError(
          resp?.data?.message !== ""
            ? resp?.data?.message
            : "Something went wrong, please try again later"
        );
      }
      setLoading(false);
    } catch (e) {
      setShowError("Something went wrong, please try again later");
      setLoading(false);
    }
  };

  const initiateTransfer = () => {
    sessionStorage.setItem("offlineUserStatus", "offlineDocuments");
    navigate("/offline-documents");
  };

  return (
    <>
      <NewHeader show={true} />
      <div className={`container ${styles.outermainContainer}`}>
        <HeadWithSubHead
          head="Transfer Money"
          subHead="Enter the amount you want to send to the beneficiary."
        />
        <Row className={styles.topConatiner}>
          <Col md={6} className={styles.detailcolumn}>
            <p
              className={styles.transferMoneySubHeading}
              style={{ marginBottom: "8px" }}
            >
              Remitter
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.remitter?.name !== ""
                  ? accountDetail?.remitter?.name
                  : "--"}
              </span>
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Email -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.remitter?.email !== ""
                  ? accountDetail?.remitter?.email
                  : "--"}
              </span>
            </p>
            <p className={styles.transferMoneyHeading}>
              Phone Number -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.remitter?.phone !== ""
                  ? accountDetail?.remitter?.phone
                  : "--"}
              </span>
            </p>
            <p
              className={styles.transferMoneySubHeading}
              style={{ marginBottom: "8px" }}
            >
              Student
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Name -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.student?.name !== ""
                  ? accountDetail?.student?.name
                  : "--"}
              </span>
            </p>
            <p
              className={styles.transferMoneyHeading}
              style={{ marginBottom: "5px" }}
            >
              Email -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.student?.email !== ""
                  ? accountDetail?.student?.email
                  : "--"}
              </span>
            </p>
            <p className={styles.transferMoneyHeading}>
              Phone Number -{" "}
              <span className={styles.transferMoneyHeading}>
                {accountDetail?.student?.phone !== ""
                  ? accountDetail?.student?.phone
                  : "--"}
              </span>
            </p>
          </Col>
          <Col md={6} className={styles.mainContainer}>
            <div className={styles.calculatorBox}>
              <Row className={styles.transactionDetails}>
                Transaction Details
              </Row>
              <Row style={{ marginBottom: "10px" }}>
                <Col
                  md={6}
                  sm={4}
                  className={styles.transferMoneyHeading}
                  style={{ padding: "0px", marginBottom: "10px" }}
                >
                  Payment Method{" "}
                </Col>
                <Col md={3} sm={4}>
                  <Form.Check
                    type="radio"
                    label="Online"
                    name="paymentMethod"
                    id="paymentMethodOnline"
                    value="Online"
                    checked={paymentMethod === "Online"}
                    onChange={handleChange}
                    className={styles.transferMoneyHeading}
                    style={{ marginBottom: "10px" }}
                  />
                </Col>
                <Col md={3} sm={4}>
                  <Form.Check
                    type="radio"
                    label="Cash"
                    name="paymentMethod"
                    id="paymentMethodCash"
                    value="Cash"
                    checked={paymentMethod === "Cash"}
                    onChange={handleChange}
                    className={styles.transferMoneyHeading}
                    style={{ marginBottom: "10px" }}
                  />
                </Col>
              </Row>
              <Row>
                <InputField
                  label={"Enter Amount"}
                  conversionValueButton={currency}
                  value={amountRUB}
                  onChange={(e) => {
                    inputAmount(e);
                  }}
                  errorMessage={amountExceedError}
                  forwardedRef={inputE1}
                  image={russiaFlag}
                  dropdown={true}
                  dropdownType={"QuoteScreen"}
                  setCurrency={setCurrency}
                  currencyOption={currencyDropdown}
                />
              </Row>
              {/* <ConversionRow data={labelValue} />; */}
              {labelValue &&
                labelValue.map((data, index) => {
                  return (
                    <Row key={index} className={styles.inputConversionRow}>
                      <Col
                        className={styles.inputBoxHeading}
                        lg={8}
                        md={7}
                        sm={7}
                        xs={7}
                      >
                        {data.Head}
                      </Col>
                      <Col
                        className={styles.inputBoxValue}
                        lg={4}
                        md={5}
                        sm={5}
                        xs={5}
                      >
                        {data.Value}
                      </Col>
                    </Row>
                  );
                })}
              <Row className="pt-3">
                <InputField
                  label={""}
                  conversionValueButton={"INR"}
                  disabled={true}
                  value={AmountConversion}
                  inputSize="quote"
                  image={IndiaImg}
                />
              </Row>
            </div>
            <Row>
              <div class="form-check" className={styles.checkMark}>
                <input
                  class="form-check-input"
                  className={styles.checkbox}
                  type="checkbox"
                  id="flexCheckChecked"
                  checked={loanCheckBox}
                  onChange={() => {
                    setLoanCheckBox(!loanCheckBox);
                  }}
                />
                <label
                  class="form-check-label"
                  className={styles.checklabel}
                  for="flexCheckChecked"
                >
                  I confirm I have a VALID EDUCATION LOAN DISBURSAL letter from
                  an RBI recognised credit provider.{" "}
                  <InfoBox
                    content={`
    TCS is applied at 5% of the overall transaction amount. In case funds from a loan are used for the transfer, the TCS applied is at 0.5%. Supporting "loan disbursement letter" from an RBI-approved loan provider is necessary for TCS relief.
  `}
                    show={false}
                    place={"right"}
                    image={
                      <span
                        style={{
                          padding: "0px 7px",
                          border: `1px solid ${themeColor}`,
                          borderRadius: "50%",
                          color: themeColor,
                          fontSize: "12px",
                        }}
                      >
                        i
                      </span>
                    }
                  />
                </label>
              </div>
            </Row>
            <Row className={styles.ProceedButtton} style={{ marginTop: "8px" }}>
              {/* {amountLimitedError !== "" && (
                <div className={styles.errorState}>{amountLimitedError}</div>
              )} */}
              {showError !== "" && (
                <div className={styles.errorState}>{showError}</div>
              )}
              <CommonButton
                title="Confirm Transfer"
                onClick={handleConfirmTransfer}
                loading={loading}
                disabled={amountRUB === undefined || loading === true}
                width={"261px"}
              />
            </Row>
          </Col>
        </Row>
        <CommonModal
          isOpen={openModal}
          onRequestClose={handleToggleModal}
          initiateTransfer={initiateTransfer}
          screen={"offlineTransaction"}
          detail={transactionDetail}
          amount={AmountConversion}
        />
      </div>
    </>
  );
}

export default OfflineTransaction;
